import React from 'react'
import Skeleton from 'react-loading-skeleton'

function SkeletonChip(props) {
  return <Skeleton style={{ fontSize: 12, marginRight: 6, paddingBottom: 1 }} width="15%" inline {...props} />
}

export default SkeletonChip
